import React from 'react';
import PropTypes from 'prop-types';
import { KeyCodes } from 'constants/index';
import ModalPortal from 'components/ModalPortal';
import modalStyles from './modal.module.scss';
import styles from './appealTypeSelect.module.scss';
import { withTranslation } from 'react-i18next';
import SearchBlock from './SearchBlock';
import TypesTree from './TypesTree';
import cx from 'classnames';
import Loader from "../Loader";

@withTranslation()
class TreeModal extends React.Component {
	
	constructor (props) {
		super(props);
		
		this.state = {
			query: '',
			submittedQuery: '',
			selectedNode: null
		};
		
		this.handleKeyPress = this.handleKeyPress.bind(this);
		this.onQueryChange = this.onQueryChange.bind(this);
		this.onSearchSubmit = this.onSearchSubmit.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onSubmitClick = this.onSubmitClick.bind(this);
	}
	
	componentDidMount () {
		document.addEventListener('keydown', this.handleKeyPress);
	}
	
	componentWillUnmount () {
		document.removeEventListener('keydown', this.handleKeyPress);
	}
	
	handleKeyPress (event) {
		if (event.keyCode === KeyCodes.ESCAPE) {
			this.props.onClose();
		}
	};
	
	onQueryChange (event) {
		this.setState({ query: event.target.value });
	}
	
	onSearchSubmit () {
		if (this.state.query !== this.state.submittedQuery) {
			this.setState(state => ({ submittedQuery: state.query }));
		}
	}
	
	onChange (newSelectedNode) {
		this.setState({ selectedNodes: newSelectedNode });
	}
	
	onSubmitClick () {
		const { selectedNodes } = this.state;
		this.props.onSubmit(selectedNodes);
	}
	
	render () {
		const { onClose, t, title, isLoading, nodeArray } = this.props;
		const { query, submittedQuery, selectedNodes } = this.state;
		const submitButtonClassName = cx('btn btn-primary', {
			['btn-disabled']: !selectedNodes
		});
		return (
			<ModalPortal onClose={onClose} className='modal-center'>
				<div className={styles.appealTypeModal}>
					{isLoading && <Loader />}
					<div className={modalStyles.modalHeader}>
						<div className={modalStyles.modalTitle}>
							{title}
						</div>
					</div>
					
					{
						<SearchBlock
							value={query}
							onChange={this.onQueryChange}
							onSubmit={this.onSearchSubmit}
							placeholder={t('Search')}
						/>}
					

					{nodeArray && nodeArray.length > 0 ? (
                        <TypesTree {...this.props} searchQuery={submittedQuery} onChange={this.onChange} />
                    ) : (
                        <div className={styles.content} />
                    )}
					
					<footer className={styles.footer}>
						<button
							type='button'
							className={submitButtonClassName}
							disabled={!selectedNodes}
							onClick={this.onSubmitClick}
						>
							{t('filter.select')}
						</button>
					</footer>
				
				</div>
			</ModalPortal>
		);
	}
}

TreeModal.propTypes = {
	onClose: PropTypes.func.isRequired
};

export default TreeModal;
